import { useEffect, useState } from "react";
import { FaWhatsapp, FaApple } from "react-icons/fa";
import api from "../lib/api";

const DEFAULT_PHONE = "62818404999";
const MSG = encodeURIComponent(
  "Hello Kratoven, I want to inquire about your Borneo Kratom products..."
);

export default function FloatingContact() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings/public")
      .then((r) => setSettings(r.data))
      .catch(() => {});
  }, []);

  const whatsapp = settings?.whatsapp || DEFAULT_PHONE;
  const imessage = settings?.imessage || settings?.whatsapp || DEFAULT_PHONE;

  return (
    <div
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 flex flex-col gap-3"
      data-testid="floating-contact"
    >
      <a
        href={`https://wa.me/${whatsapp}?text=${MSG}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn"
        style={{ background: "#25D366" }}
        aria-label="WhatsApp Kratoven"
        data-testid="whatsapp-btn"
      >
        <FaWhatsapp size={24} />
      </a>

      <a
        href={`sms:+${imessage}&body=${MSG}`}
        className="floating-btn"
        style={{ background: "#0A84FF" }}
        aria-label="iMessage Kratoven"
        data-testid="imessage-btn"
      >
        <FaApple size={22} />
      </a>
    </div>
  );
}
